module.exports = __webpack_public_path__ + "media/icons/link-e9f4a109caec31b8bdf3b7ace534504f.svg";